import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import PageNotFound from "./Components/PageNotFound";



const TosApp = () => {
  return (
    <div className="TocApp">
      <Router>
        <Switch>
          <Redirect exact from="/termsandconditions" to="/pagenotfound" />
          <Redirect exact from="/termsandconditionsowner/:id/:ownertype" to="/pagenotfound" />
          <Redirect exact from="/termsandconditions/:id" to="/pagenotfound" />
          <Redirect exact from="/termsofuse/:id" to="/pagenotfound" />
          <Redirect exact from="/termsofuseowner/:id/:ownertype" to="/pagenotfound" />
          <Redirect exact from="/termsofuse" to="/pagenotfound" />
          <Route path="/pagenotfound" exact component={PageNotFound} />
        </Switch>
      </Router>
    </div>
  );
};

export default TosApp;